import axios from "axios";
import { toast } from "react-toastify";
import { MessageResultState } from "../types/general-types";
import { serializeParams } from "../utils/queryParamsHelper";

const languages: { [key: string]: string } = {
  tr: "tr-TR",
  en: "en-US",
};
const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 0,
  paramsSerializer: (params: any) => serializeParams(params),
});

declare module "axios" {
  export interface AxiosRequestConfig {
    skipSuccessToast?: boolean;
  }
}

http.interceptors.request.use(
  (req) => {
    req.headers = req.headers || {};
    req.headers.common = (req.headers as any).common || {};

    const commons = (req.headers as any).common as Record<string, unknown>;

    if (!commons.hasOwnProperty("Content-Type")) {
      commons["Content-Type"] = "application/json";
    }

    const browserLang = navigator.language || (navigator as any).userLanguage;
    commons["Accept-Language"] = languages[browserLang] || "en-US";

    return req;
  },
  (err) => Promise.reject(err)
);

http.interceptors.response.use(
  (res) => {
    if (res?.data?.state === MessageResultState.ERROR && res?.data?.message) {
      toast.error(res?.data?.message, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: false,
        closeButton: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: { whiteSpace: "pre-line" },
      });
    } else if (
      res?.data?.state === MessageResultState.SUCCESS &&
      res?.data?.message
    ) {
      const skip = res.config.skipSuccessToast;
      if (
        !skip &&
        res?.data?.state === MessageResultState.SUCCESS &&
        res?.data?.message
      ) {
        toast.success(res?.data?.message, {
          position: "top-right",
          autoClose: 8000,
          hideProgressBar: false,
          closeOnClick: false,
          closeButton: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: { whiteSpace: "pre-line" },
        });
      }
    } else if (
      res?.data?.state === MessageResultState.WARNING &&
      res?.data?.message
    ) {
      toast.warning(res?.data?.message, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: false,
        closeButton: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: { whiteSpace: "pre-line" },
      });
    }

    return res;
  },
  (err) => {
    const { response: res } = err;

    if (res?.status >= 400 && res?.data?.error?.code !== "smart") {
      return Promise.reject(res.data?.message ?? res.data);
    }

    if (res?.data?.message) {
      toast.error(res.data.message, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: { whiteSpace: "pre-line" },
      });

      return Promise.reject(res.data?.message);
    }

    if (res?.data?.error?.code === "smart" && res?.data?.error?.message) {
      toast.error(res?.data?.error?.message, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        closeButton: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: { whiteSpace: "pre-line" },
      });

      return Promise.reject(res?.data?.error?.message);
    }
    return Promise.reject(err);
  }
);

export default http;
